import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import sendRoleClearRequest from "./components/sendRoleClearRequest.vue";
import infoList from "../../mixins/infoList";
import roleClearTable from "./components/roleClearTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
import { getRoleClearList } from "@/api/roleClear";
import { roleClearStateList } from "@/define/roleClearDefine";
import serverList from "../../components/serverList/serverOptions.vue";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    sendRoleClearRequest: sendRoleClearRequest,
    DataOptions: DataOptions,
    roleClearTable: roleClearTable
  },
  data: function data() {
    return {
      listApi: getRoleClearList,
      requestDialog: false,
      state: 0,
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      options: roleClearStateList
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.onQueryBtn();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    newRequest: function newRequest() {
      this.requestDialog = true;
    },
    onClosePanel: function onClosePanel() {
      this.requestDialog = false;
      this.onQueryBtn();
    },
    onEdit: function onEdit(data) {
      var _this2 = this;
      this.requestDialog = true;
      setTimeout(function () {
        _this2.$refs.dialog.initData(data);
      }, 10);
    },
    onQueryBtn: function onQueryBtn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.searchInfo.sdate = _this3.formTime[0];
              _this3.searchInfo.edate = _this3.formTime[1];
              _this3.searchInfo.state = _this3.state;
              _context2.next = 5;
              return _this3.getTableData();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};